import { Plus } from 'lucide-react';
import * as React from 'react';

import { BlurredContainer } from '@/features/insights/components/blurred-container';
import { Card, CardContent } from '@/shared/components/ui/card';

export const ProjectSlideCardEmpty = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    hidePlusIcon?: boolean;
    isBlurred?: boolean;
  }
>((props, ref) => {
  return (
    <BlurredContainer
      className="size-full"
      isBlurred={props.isBlurred ?? false}
    >
      <Card
        ref={ref}
        variant="informationAlt"
        className="size-full cursor-pointer p-0"
        {...props}
      >
        <CardContent className="flex h-full items-center justify-center">
          {!props.hidePlusIcon && (
            <div className="flex size-16 items-center justify-center rounded-full border border-white/50">
              <Plus className="size-6" />
            </div>
          )}
        </CardContent>
      </Card>
    </BlurredContainer>
  );
});
ProjectSlideCardEmpty.displayName = 'ProjectSlideCardEmpty';
